import * as React from 'react'
import { classNames } from '@/ui/utils/main'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, fwdRef) => (
    <textarea
      className={classNames(
        'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none',
        className,
      )}
      ref={fwdRef}
      {...props}
    />
  ),
)
Textarea.displayName = 'Textarea'
